/**
 * Публичный лендинг: оферта, политика, страницы «Полезного». Локально (`vite`) — dev-сервер лендинга
 * (`next dev -p 3032`), чтобы с localhost не уходить на боевой сайт (владелец 2026-10-25); переопределяется
 * VITE_LANDING_URL. Сборка для прода — lomora.ru.
 */
export const LANDING_URL: string =
  (import.meta.env.VITE_LANDING_URL as string | undefined) ?? (import.meta.env.DEV ? 'http://localhost:3032' : 'https://lomora.ru');
